import {
  faCaretDown,
  faCaretUp,
  faHyphen,
} from '@fortawesome/pro-solid-svg-icons';

import { IconDefinition } from 'atoms/icons';
import { Color } from 'style/types';

export const getColorAndIcon = (
  score: number,
  opponentScore: number
): [Color, IconDefinition] => {
  if (score > opponentScore) return ['var(--c-score-high)', faCaretUp];
  if (score < opponentScore) return ['var(--c-red-600)', faCaretDown];
  return ['var(--c-neutral-600)', faHyphen];
};
